// MCP / AI integrations are disabled unless the build sets REACT_APP_MCP_ENABLED=true exactly.
export const mcpEnabled = () => process.env.REACT_APP_MCP_ENABLED === 'true';

// Only the OAuth consent URL may be used as a post-login return target (no open redirects).
export const safeLoginReturn = value => (typeof value === 'string' && /^\/oauth\/consent\?req=[\w.~%-]+$/.test(value) ? value : null);
